import api from '../api/index.js';
import { transform } from 'ol/proj';

export const RECEIVE_RGEO_ADDRESS = 'RECEIVE_RGEO_ADDRESS';
function receiveAddress(json, coords) {
	// var coords = ol.proj.transform([json.lon, json.lat], 'EPSG:4326', 'EPSG:3857');

	return {
		type: RECEIVE_RGEO_ADDRESS,
		coords: [parseFloat(coords[0].toFixed(2)), parseFloat(coords[1].toFixed(2))],
		address: json.adrese + (json.index && ', ' + json.index),
		receivedAt: Date.now()
	};
}

export function revGeoAddress(coordsM, inputProj = 'EPSG:3857') {
	if (inputProj) {
		var coords = transform(coordsM, inputProj, 'EPSG:4326');
	} else {
		var coords = coordsM;
	}

	return function(dispatch) {
		
		return api('revGeo').get({ lat: coords[1], lon: coords[0], returnTerritUnitAfter: '300' }, function(data) {
			if (data) {
				data.getInt = parseInt(Math.random() * 10000);
	
				dispatch(receiveAddress(data, coordsM));
			}
			
		});
	};
}
